var map = {
	"./bodyback.svg": "e6a6",
	"./bodyfront.svg": "7c6b",
	"./check.svg": "f222",
	"./checkbox-check.svg": "ec0a",
	"./checkbox-focus.svg": "999e",
	"./checkbox-null.svg": "c50a",
	"./control-button-icon-button-normal.svg": "d25e",
	"./control-processor-1.svg": "f518",
	"./control-processor-2.svg": "7fc5",
	"./control-processor-3.svg": "e488",
	"./control-processor-4.svg": "4aa0",
	"./control-processor-5.svg": "665f",
	"./control-radio-check.svg": "cac8",
	"./control-radio-null.svg": "8a89",
	"./control-switch-off.svg": "952a",
	"./control-switch-on.svg": "06ef",
	"./dr-illu-1.svg": "5f7f",
	"./dr-illu-2.svg": "d677",
	"./empty.svg": "8479",
	"./exhausting.svg": "2650",
	"./ic-back.svg": "e5f7",
	"./icon-basis-ic-back.svg": "b137",
	"./icon-basis-ic-close.svg": "114d",
	"./icon-basis-ic-confirm.svg": "f736",
	"./icon-basis-ic-delete.svg": "feac",
	"./icon-basis-ic-pen.svg": "277e",
	"./icon-button-ic-pdf.svg": "768f",
	"./icon-button-ic-pic.svg": "c15a",
	"./icon-button-ic-print.svg": "f065",
	"./icon-list-check.svg": "c0d3",
	"./icon-list-empty.svg": "b2e8",
	"./icon-small-arrow-down-white.svg": "5958",
	"./icon-small-arrow-down.svg": "e9af",
	"./icon-small-arrow-left.svg": "a350",
	"./icon-small-arrow-right.svg": "a985",
	"./icon-small-arrow-up-white.svg": "f8bc",
	"./icon-small-arrow-up.svg": "acc5",
	"./illu-card-beschwerden-breath.svg": "2fbe",
	"./illu-card-beschwerden-children.svg": "2550",
	"./illu-card-beschwerden-digestion.svg": "14b4",
	"./illu-card-beschwerden-dizzy.svg": "aec3",
	"./illu-card-beschwerden-exhausting.svg": "4971",
	"./illu-card-beschwerden-fever.svg": "3c8b",
	"./illu-card-beschwerden-gynecological.svg": "45d5",
	"./illu-card-beschwerden-pain.svg": "3f13",
	"./illu-card-beschwerden-paralysis.svg": "e1fb",
	"./illu-card-beschwerden-rash.svg": "d41a",
	"./illu-card-beschwerden-sensory-perception.svg": "b55c",
	"./illu-card-beschwerden-swelling.svg": "89d8",
	"./illu-icon-46-chat.svg": "b759",
	"./illu-icon-46-lock-safe.svg": "3161",
	"./illu-icon-46-mobile.svg": "0dae",
	"./illu-icon-46-money-time.svg": "282a",
	"./illu-icon-80-talk-plus.svg": "199c",
	"./nett-doctor.svg": "ae00",
	"./normalface.svg": "ea94",
	"./panic.svg": "fbb7",
	"./plus.svg": "8a37",
	"./pregnant.svg": "ca6a",
	"./sad.svg": "c4e4",
	"./sensory-perception.svg": "8ed0",
	"./sideface.svg": "db36"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";